import { Enum } from '@utils/enum';

export const types = Enum(
  // HEADINGS
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  // TEXTS
  'perex',
  'regular',
  'reduced',
  'small',
  'tiny',
  // HERO
  'hero1',
  'hero2',
  'hero3',
  // Other
  'link',
);

export type TextType = keyof typeof types;
